import { PortfolioApiResponseResults } from './types';

export type State = {
  portfolio: PortfolioDataState;
};

export const state: State = {
  portfolio: {} as PortfolioDataState,
};

type PortfolioDataState = {
  portfolioData: Array<PortfolioApiResponseResults>;
  portfolioDataCount: number;
};
